import ManagedLookup from '../components/ManagedLookup';
import fields from './fields';
import useLookupPage from '../hooks/useLookupPage';
import columns from './columns';

const Dimensions = ({ definition }) => {
    const page = useLookupPage('dimensions', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} />;
};

export default Dimensions;
